import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Sidebar from './components/Sidebar';
import Library from './pages/Library';
import Category from './pages/Category';
import Favorites from './pages/Favorites';
import CreatePhrase from './pages/CreatePhrase';
import StickerSuggestion from './pages/StickerSuggestion';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch('http://localhost/sticker-library/api/index.php/categories');
      const data = await response.json();
      if (data.data) {
        setCategories(data.data);
      }
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
      // Dados mockados para demonstração
      setCategories([
        { id: 1, name: 'Bom Dia', slug: 'bom-dia', emoji: '☀️', sticker_count: 53 },
        { id: 2, name: 'Boa Noite', slug: 'boa-noite', emoji: '🌙', sticker_count: 42 },
        { id: 3, name: 'Boa Tarde', slug: 'boa-tarde', emoji: '🌤️', sticker_count: 38 },
        { id: 4, name: 'Férias', slug: 'ferias', emoji: '🏖️', sticker_count: 25 },
        { id: 5, name: 'Maternidade', slug: 'maternidade', emoji: '👶', sticker_count: 31 },
        { id: 6, name: 'Afiliadas', slug: 'afiliadas', emoji: '💚', sticker_count: 28 },
        { id: 7, name: 'Dias da Semana', slug: 'dias-da-semana', emoji: '📅', sticker_count: 35 },
        { id: 8, name: 'Pet', slug: 'pet', emoji: '🐾', sticker_count: 22 },
        { id: 9, name: 'Café', slug: 'cafe', emoji: '☕', sticker_count: 18 },
        { id: 10, name: 'Frases', slug: 'frases', emoji: '✍️', sticker_count: 45 },
        { id: 11, name: 'Academia', slug: 'academia', emoji: '💪', sticker_count: 20 },
        { id: 12, name: 'Clima', slug: 'clima', emoji: '🌦️', sticker_count: 15 },
        { id: 13, name: 'Lar e Rotina', slug: 'lar-e-rotina', emoji: '🏠', sticker_count: 27 },
        { id: 14, name: 'Fé e Espiritualidade', slug: 'fe-e-espiritualidade', emoji: '🙏', sticker_count: 33 },
        { id: 15, name: 'Auto Cuidado', slug: 'auto-cuidado', emoji: '🧘', sticker_count: 19 },
        { id: 16, name: 'Comida', slug: 'comida', emoji: '🍔', sticker_count: 24 },
        { id: 17, name: 'Home Office', slug: 'home-office', emoji: '💻', sticker_count: 16 }
      ]);
    }
  };

  return (
    <Router>
      <div className={`app ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <Sidebar 
          isOpen={sidebarOpen} 
          onToggle={() => setSidebarOpen(!sidebarOpen)}
          categories={categories}
          activeCategory={activeCategory}
          onCategorySelect={setActiveCategory}
        />
        
        <main className={`main-content ${sidebarOpen ? '' : 'full-width'}`}>
          <Routes>
            <Route 
              path="/" 
              element={
                <Library 
                  categories={categories}
                  onCategorySelect={setActiveCategory}
                />
              } 
            />
            <Route 
              path="/category/:id" 
              element={
                <Category 
                  onCategorySelect={setActiveCategory}
                />
              } 
            />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/create-phrase" element={<CreatePhrase />} />
            <Route path="/sticker-suggestion" element={<StickerSuggestion />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
      
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

export default App;
